import React, { useEffect, useState } from "react";
import Title from "../components/TitleChanger";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../store";
import {
  getUserWorkflows,
  getWorkflowLoading,
  getWorkflowError,
  fetchUserWorkflows,
  editWorkflow,
} from "../slices/workflowSlice";

export default function EditWorkflowView() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Get all workflows from store
  const workflows = useSelector(getUserWorkflows);
  const loading = useSelector(getWorkflowLoading);
  const error = useSelector(getWorkflowError);

  // Find the workflow by id
  const workflow = workflows.find((w) => w.id === Number(id));

  // Local state for editing
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState(""); // <-- new
  const [color, setColor] = useState("#fafafa"); // <-- new, default color
  const [background, setBackground] = useState("#0088cc"); // <-- new, default color

  useEffect(() => {
    if (!workflows.length) {
      dispatch(fetchUserWorkflows());
    }
  }, [dispatch, workflows.length]);

  useEffect(() => {
    if (workflow) {
      setTitle(workflow.title || "");
      setCategory(workflow.category || "");
      setDescription(workflow.description || "");
      setIcon(workflow.icon || "");
      setColor(workflow.color || "#fafafa");
      setBackground(workflow.background || "#0088cc");
    }
  }, [workflow]);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    if (id && title && description) {
      dispatch(
        editWorkflow(Number(id), {
          title,
          category,
          description,
          icon,
          color,
          background,
        })
      );
      navigate("/app/workflows");
    }
  };

  if (loading) return <div className="container py-4">Loading workflow...</div>;
  if (error)
    return <div className="container py-4 alert alert-danger">{error}</div>;
  if (!workflow)
    return <div className="container py-4">Workflow not found.</div>;

  return (
    <div className="page">
      <Title pageTitle={"Workflows | "} />
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div className="container py-4">
              <h2>Edit Workflow</h2>
              <form onSubmit={handleSave} style={{ maxWidth: 600 }}>
                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <input
                    className="form-control"
                    type="text"
                    value={title}
                    required
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Category (optional)</label>
                  <input
                    className="form-control"
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={description}
                    required
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Icon (emoji or name)</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={icon}
                    onChange={(e) => setIcon(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Color</label>
                  <input
                    className="form-control form-control-color"
                    type="color"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    style={{
                      width: 60,
                      height: 40,
                      padding: 0,
                      border: "none",
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Backgorund</label>
                  <input
                    className="form-control form-control-color"
                    type="color"
                    value={background}
                    onChange={(e) => setBackground(e.target.value)}
                    style={{
                      width: 60,
                      height: 40,
                      padding: 0,
                      border: "none",
                    }}
                  />
                </div>
                <button className="btn btn-primary me-2" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={() => navigate("/app/workflows")}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
